<template>
  <a
    class="engagement-result-auth-wall text-button"
    href="#"
    @click.prevent="handleLoginDialog"
  >
    <h2
      class="engagement-result-auth-wall__heading"
      data-test-id="engagement-result-auth-wall-heading"
    >{{ heading }} </h2>
    <p
      class="engagement-result-auth-wall__copy"
      data-test-id="engagement-result-auth-wall-copy"
    >{{ copy }}</p>
    <p
      class="engagement-result-auth-wall__cta-text"
      data-test-id="engagement-result-auth-wall-cta-text"
    >
      Sign in
      <icon-component
        name="caret"
        title="caret icon"
        class="icon--small engagement-result-auth-wall__cta-icon"
      />
    </p>
  </a>
</template>

<script>
export default {
  name: 'EngagementResultAuthWall',
  props: {
    engagementType: {
      type: String,
      required: true,
    },
  },
  computed: {
    heading() {
      const defaultHeadingForEngagementType = {
        poll: 'Thank you for sharing',
        thisOrThat: 'Thank you for sharing',
        quizlet: 'Thank you for taking the quiz',
      }[this.engagementType] || '';

      return defaultHeadingForEngagementType;
    },
    copy() {
      const defaultCopyForEngagementType = {
        poll: 'Create an account to see the answer',
        thisOrThat: 'Create an account to see responses',
        quizlet: 'Create an account to see the answer',
      }[this.engagementType] || '';

      return defaultCopyForEngagementType;
    },
  },
  methods: {
    handleLoginDialog(event) {
      this.$snowplow.trackButtonEvent({
        data: {
          type: 'log in',
          text: event.target.textContent.trim(),
          classes: event.target.classList,
          id: event.target.id,
        },
      });
      this.$store.commit('setIsUGC', true);
      this.$store.dispatch('openLoginDialog');
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '@/stylesheets/components/_engagement-result-auth-wall';
</style>
